// work data

export const Work = [
    {
        id:1,
        name:"CartTel Website",
        description:"DropShipping Website",
        demo:"https://reporite.netlify.app/",
        github:"https://github.com/folajhimie/Reporite"
        
    },
    {
        id:2,
        name:"TobiCharity Website",
        description:"TobiCharity Website",
        demo:"https://tobcharityinitiative.org/",
        github:"https://github.com/Olas3ni/OlaBrothers"
        
    },
    {
        id:3,
        name:"Fintech Website",
        description:"Banking Web App",
        demo:"https://youshacoin.netlify.app",
        github:"https://github.com/folajhimie/Tech-Haven"
        
    },
    {
        id:4,
        name:"Tesla Clone",
        description:"This is a Tesla Clone",        
        demo:"https://tesla-clone-elon.netlify.app/",
        github:"https://github.com/folajhimie/tesla-clone"
       
    },
    {
        id:5,
        name:"Job Recruitment Website",
        description:"The Largest Job Hunting Website in Africa.",
        demo:"https://jobber-web.netlify.app/",
        github:"https://github.com/folajhimie/Jobber-web"
    },
    {
        id:6,
        name:"Ecommerce website",
        description:"This is an ecommerce application where you can view Order, Employees, Charts.",        
        demo:"https://shop-verse-web.netlify.app/",
        github:"https://github.com/folajhimie/Shop-verse"
        
    },
    {
        id:7,
        name:"Logistics Website",
        description:"This is for Logistics, Procurement and Supply Chain.",     
        demo:"https://logistics-web.netlify.app/",
        github:"https://github.com/folajhimie/"
    }
] 